import { createIntl, createIntlCache } from "react-intl";
import { toast } from "react-toastify";
//import { ErrorResponse } from "@apollo/client/link/error";
import { getLocale } from "../../../../lang";
import { messageWithDefault } from "../../../../utils/messages/general";

const intl = (() => {
  const { locale, messages } = getLocale();
  const cache = createIntlCache();

  return createIntl({ locale, messages }, cache);
})();

export const errorHandler = ({ graphQLErrors, networkError }: any): void => {
  if (graphQLErrors?.length) {
    graphQLErrors.forEach(error => {
      console.error("==> GraphQL error:", error);

      const code = error.extensions?.code as string | undefined;

      if (
        [
          "GRAPHQL_PARSE_FAILED",
          "GRAPHQL_VALIDATION_FAILED",
          "BAD_USER_INPUT",
          "FORBIDDEN",
          "PERSISTED_QUERY_NOT_FOUND",
          "PERSISTED_QUERY_NOT_SUPPORTED",
          "INTERNAL_SERVER_ERROR",
        ].includes(code || "")
      ) {
        toast(
          intl.formatMessage({
            id:
              error.message &&
              messageWithDefault(
                intl,
                error.message,
                "page.error.default.message"
              ),
          }),
          { type: "error" }
        );
      } else if (code === "BAD_REQUEST_EXCEPTION") {
        toast(intl.formatMessage({ id: "page.error.default.message" }), {
          type: "error",
        });
      } else if (error.message === "error.category.not.authorized") {
        toast(intl.formatMessage({ id: "page.error.unauthorized.message" }), {
          type: "error",
        });
      }
    });
  }

  if (networkError) {
    console.error("==> Network error:", networkError);
    toast(intl.formatMessage({ id: "page.error.network.message" }), {
      type: "error",
    });
  }
};

export const fetchPolicy = "network-only";
